import AgathaMessage from 'components/AgathaMessage/AgathaMessage';
import { ShimmerText } from './ShimmerText';
import SpiralIndicator from './SpiralIndicator';
import { Box } from '@mui/material';
import { selectBrowserAgentLoadingTexts } from 'reducers/workflows';
import { useAppSelector } from 'hooks';

const SIZE = 24;

export const BrowserAgentLoading = () => {
  const loadingTexts = useAppSelector(selectBrowserAgentLoadingTexts);

  return (
    <AgathaMessage
      hasLink={false}
      hideTimestamp={true}
      isAdminOnly={false}
      isAuthorIconVisible={true}
      isLiveChat={false}
      stepIndex={-1}
      timestamp={Date.now()}
    >
      <Box alignItems='center' display='flex' flexDirection='row' gap={2}>
        <SpiralIndicator height={SIZE} width={SIZE} />
        <ShimmerText texts={loadingTexts} />
      </Box>
    </AgathaMessage>
  );
};
